import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import TableSorting from '@components/common/TableSorting/TableSorting';
import TooltipSort from '@components/common/TooltipSort/TooltipSort';

import { initialSorting } from '@constants/tableSorting';

import useTranslation from '@hooks/useTranslation';

import type { IFacilityGroupItem } from '@model/facilityGroup';
import type { ITableSorting } from '@model/tableSorting';

import { getSortedData } from '../../helpers/getSortedData';
import style from './style.module.scss';

interface IProps {
  facilityGroupId: number;
  facilityList: Array<IFacilityGroupItem>;
}

const NestedTableFacilityGroup: React.FC<IProps> = ({ facilityGroupId, facilityList }) => {
  const { t } = useTranslation();

  const [sorting, setSorting] = useState<ITableSorting>(initialSorting);

  const GROUP_SORT_TOOLTIP_ID = `group-sort-tooltip-id-${facilityGroupId}`;

  const tableData = getSortedData(sorting, facilityList);

  return (
    <>
      <table className={style.nestedTable}>
        <thead>
          <tr>
            <th>
              {t('Facility')}
              <TableSorting
                sortingKey="name"
                sorting={sorting}
                setSorting={setSorting}
                tooltipId={GROUP_SORT_TOOLTIP_ID}
              />
            </th>
            <th>
              {t('Status')}
              <TableSorting
                sortingKey="statusTypeName"
                sorting={sorting}
                setSorting={setSorting}
                tooltipId={GROUP_SORT_TOOLTIP_ID}
              />
            </th>
            <th className={style.showTablet}>
              {t('Country')} / <br />
              {t('Language')}
              <TableSorting
                sortingKey="country"
                sorting={sorting}
                setSorting={setSorting}
                tooltipId={GROUP_SORT_TOOLTIP_ID}
              />
            </th>
            <th className={style.showFull}>
              {t('Country')}
              <TableSorting
                sortingKey="country"
                sorting={sorting}
                setSorting={setSorting}
                tooltipId={GROUP_SORT_TOOLTIP_ID}
              />
            </th>
            <th className={style.showFull}>
              {t('Language')}
              <TableSorting
                sortingKey="language"
                sorting={sorting}
                setSorting={setSorting}
                tooltipId={GROUP_SORT_TOOLTIP_ID}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((facility) => (
            <tr key={uuidv4()}>
              <td>{facility.name}</td>
              <td>{facility.statusTypeName}</td>
              <td className={style.showTablet}>
                {facility.country}
                <div className={style.languageName}>{facility.language}</div>
              </td>
              <td className={style.showFull}>{facility.country}</td>
              <td className={style.showFull}>{facility.language}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <TooltipSort id={GROUP_SORT_TOOLTIP_ID} sorting={sorting} />
    </>
  );
};

export default NestedTableFacilityGroup;
